import { createAxios } from './axiosHttpMarconi';
export const franquiciadoraService = {
    getFranquiciadora
}

function getFranquiciadora() {
    const axios = createAxios();
    let urlPath = `/franquiciadora`;
    return axios.get(urlPath);
}